import PortfolioRiskDistribution from './PortfolioRiskDistribution'

export default PortfolioRiskDistribution
